<template lang="pug">
  .table-responsive
    table#tbTagsMovimientos.table.is-striped.is-fullwidth.is-narrow
      thead
        tr
          th
            | #
          th 
            | Tag
          th 
            | No. Económico
          th 
            | Fecha
          th 
            | Hora
          th 
            | Caseta
          th 
            | Carril
          th 
            | Importe
          th 
            | Clase
          th 
            | Consecar
          th 
            | Fecha Aplicación
      tbody
        tr(v-for="(mov, index) in movs" :key="mov.id")
          td.is-size-7
            a.button.is-black.is-rounded.is-small {{ index + 1 }}
          td.is-size-7
            span.tag
              | {{ mov.tag }}
          td.is-size-7
            span.tag
              | {{ mov.noEconomico }}
          td.is-size-7
            span.tag
              | {{ mov.fecha }}
          td.is-size-7
            span.tag
              | {{ mov.hora }}
          td.is-size-7
            span.tag
              | {{ mov.caseta }}
          td.is-size-7
            span.tag
              | {{ mov.carril }}
          td.is-size-7
            span.tag.is-black
              | {{ mov.importe | currency }}
          td.is-size-7
            span.tag(:class="mov.clase == 1 ? 'is-light' : 'is-danger'")
              | {{ mov.clase == 1 ? 'Válido' : 'Inválido' }}
          td.is-size-7
            span.tag
              | {{ mov.consecar }}
          td.is-size-7
            span.tag.is-black
              | {{ mov.fechaAplicacion }}
    .notification(v-show="movs.length < 1")
      strong  No se encontraron registros.
</template>

<script>
  export default {
    name: 'TbTagsMovimientos',
    props: {
      movs: {
        type: Array,
        default: []
      },
      movSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        itemsSelected: {},
      }
    },
    watch: {
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      movSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.movSel)
      },
    },
    methods: {
      iniciarComponente () {
      },
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/TbTagsMovimientos.vue